'use client';

import { createContext, useContext, type ReactNode } from 'react';

export type AdoptShelterQuizThemeVars = Record<string, string>;

const Ctx = createContext<AdoptShelterQuizThemeVars | null>(null);

export function AdoptShelterQuizThemeVarsProvider({
  value,
  children,
}: {
  value: AdoptShelterQuizThemeVars | null;
  children: ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useOptionalAdoptShelterQuizThemeVars(): AdoptShelterQuizThemeVars | null {
  return useContext(Ctx);
}
